import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[ngAutofocus]'
})
export class NgAutofocusDirective implements OnInit{

  private _ngAutofocus;
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    if (this._ngAutofocus || typeof this._ngAutofocus === 'undefined') {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 10);
    }
  }

  @Input() set ngAutofocus(condition: boolean) {
    this._ngAutofocus = condition;
  }

}
